import { Outlet } from "react-router-dom"
const MiddlewareRoute = () => <Outlet />

export default MiddlewareRoute
